import React from 'react';
import ReactLoading from 'react-loading';
import { useAlert } from 'react-alert';

export const Subscriptions = props => {

    //Stores the members communication preferences
    const [email, setEmail] = React.useState(false);
    const [sms, setSms] = React.useState(false);
    const [gamingSMS, setGamingSMS] = React.useState(false);
    const [gamingEmail, setGamingEmail] = React.useState(false);

    //Stores the loading state
    const [notLoading, setNotLoading] = React.useState(true);

    //Sets the hidden state of the back and save button
    const [hideButton, setHideButton] = React.useState(false);

    //Gets the members subscriptions and checks the appropriate boxes
    React.useEffect(() =>{
        if('parentIFrame' in window){
            window.parentIFrame.scrollTo(0, 0);
        }

        if(window.location.pathname !== '/subscriptions'){
            setHideButton(true);
        }
                    
        // console.log(props.isEdited);
        if(props.isEdited){
            setEmail(props.subscriptionsData.email);
            setSms(props.subscriptionsData.sms);
            setGamingEmail(props.subscriptionsData.gamingEmail);
            setGamingSMS(props.subscriptionsData.gamingSMS);
        } else {

            setNotLoading(false);
            fetch(localStorage.getItem('server') + 'subscription', {
                method: 'GET',
                headers: {
                    token: sessionStorage.getItem('token'),
                    memberNumber: sessionStorage.getItem('memberNumber')
                }
            })
            .then(function(response){
                return response.json();
            })
            .then(function(data){
                if(data.status === 401){
                    // console.log("Invalid Token - Redirecting to login");
                    alert.show(
                    <span ref={sessionRef}>
                        Your session has expired. Please login to continue.
                    </span>
                    , {
                        title: "Session Expired"
                    });
                    // window.location.replace(window.location.origin);
                } else if(data.status === 429){
                    alert.show(
                        <span ref={sessionRef}>
                            Too many requests. Please try again later.
                        </span>
                        , {
                            title: "Uh Oh..."
                    });
                } else {
                data.data.forEach(function(subscription){
                    switch(subscription.netsuiteID){
                        case 11:
                            if(subscription.subscribed === 1){
                                setEmail(true);
                            }
                            break;
                        
                        case 12:
                            if(subscription.subscribed === 1){
                                setSms(true);
                            }
                            break;
                        case 9:
                            if(subscription.subscribed === 1){
                                setGamingSMS(true);
                            }
                            break;
                        case 8:
                            if(subscription.subscribed === 1){
                                setGamingEmail(true);
                            }
                            break;
                        default:
                            break;
                    }
                });
                setNotLoading(true);

            }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() =>{
        formChange();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [email, sms, gamingSMS, gamingEmail])

    const toggleEmail = () =>{
        setEmail(!email);
    }

    const toggleSms = () =>{
        setSms(!sms);
    }

    const toggleGamingSMS = () =>{
        setGamingSMS(!gamingSMS);
    }

    const toggleGamingEmail = () =>{
        setGamingEmail(!gamingEmail);
    }

    const alert = useAlert();

    const save = () =>{
        var body = {
            'email': email,
            'sms': sms,
            'gamingEmail': gamingEmail,
            'gamingSMS': gamingSMS
        };
        
        //Calls the function that is located inside the parent component
        props.submit(body);
    }

    // const closeDialog = () =>{
    //     document.querySelectorAll('.MuiDialog-root').forEach(e=> e.remove());
    // }

    //Remove this confirm yes button and replace it with an alert instead sayin gthat your changes has been made
    // const confirmChange = () =>{
    //     alert.show(<span className="d-flex justify-content-center" id="confirm-dialog"><button className='btn btn-primary blue-bg' style={{margin: "0 20px 0 0", width: "60px"}} onClick={save}>Yes</button><button style={{width: "60px"}} className='btn btn-primary blue-bg' onClick={closeDialog}>No</button></span>,{
    //         title: <p style={{padding: "20px 0 0 0", margin: "0"}}><strong>Would you like to save these changes?</strong></p>,
    //         hideClose: true
    //     });
    // }

    const formChange = () =>{
        var body = {
            'email': email,
            'sms': sms,
            'gamingEmail': gamingEmail,
            'gamingSMS': gamingSMS
        };

        // console.log(body);
        props.saveData(body);
    }

    //Handles the redirect of expired session
    const sessionRef = (node)=>{
        if(node === null){
            window.location.replace(window.location.origin);
        }
    }

    return(
        <div>
            <div className="overlay" hidden={notLoading}>
            <ReactLoading className="loading" type={'cylon'} color={'#61dafb'} height={300} width={300}/>
            </div>
            <div className="container">
                <h2 className="text-center"><strong>Preferences</strong></h2>
                <p className="text-justify">As a member you have access to some great benefits and exclusive offers. Complete the form below so you don’t miss out! Don’t worry – you won’t be bombarded, but you will be delighted! </p>
                <p className="text-justify">Please keep in mind there are times that we are required by law to communicate with every member individually, even if multiple members share the same email address or phone number. This will only ever be for our <strong>Annual General Meetings</strong>, when your <strong>membership is expiring</strong> or if there is there is an <strong>urgent member notice</strong>.</p>

                <h3><strong>Marketing Communication</strong></h3>
                <p className="text-justify">How you would like to receive these notices?</p>
                
                <div className="preferences">
                    <input className="subscriptionCB" type="checkbox" value="email" onChange={toggleEmail} checked={email}/>
                    <label className="formLabel subscriptionLB">Email</label>

                    <br/>

                    <input className="subscriptionCB" type="checkbox" value="sms" onChange={toggleSms} checked={sms}/>
                    <label className="formLabel subscriptionLB">SMS</label>
                </div>

                <br/>

                <h3><strong>Gaming</strong></h3>
                <p className="text-justify">Opt in to receive Gaming related content through the communication of your choice.</p>
                
                <div className="preferences">
                    <input className="subscriptionCB" type="checkbox" value="gamingEmail" checked={gamingEmail} onChange={toggleGamingEmail} />
                    <label className="formLabel subscriptionLB">Email</label>
                    
                    <br/>

                    <input className="subscriptionCB" type="checkbox" value="gamingSMS" checked={gamingSMS} onChange={toggleGamingSMS} />
                    <label className="formLabel subscriptionLB">SMS</label>

                    <br/>
                </div>
                <br/>
                <button className="form-btn btn btn-primary float-left formButton" hidden={hideButton} onClick={props.redirectHome}>Back</button>
                {!hideButton &&
                    <button id="gtm-preferences" className="form-btn btn btn-primary float-right formButton" hidden={hideButton} onClick={save}>Save</button>
                }
            </div>
        </div>
    )
}